import Types from '../types';

const initialState = { skip: 0, limit: 5 };

export default (reducerState = initialState, action) => {
  switch (action.type) {
    case Types.SET_QUERY_STRING:
      return action.payload;
    default:
      return reducerState;
  }
};
